import React, {memo, useEffect, useRef} from "react";

const ResponsiveRow = memo(({data, index, style}) => {
    const rowRef = useRef();
    const {items, setRowHeight, ItemElementType} = data;

    useEffect(() => {
        if (rowRef.current) {
            setRowHeight(index, rowRef.current.clientHeight);
        }
    }, [index, rowRef, setRowHeight]);

    return (
        <div style={style}>
            <div ref={rowRef}>
                {ItemElementType ? <ItemElementType {...items[index]}/> : items[index]}
            </div>
        </div>
    );
});

export default ResponsiveRow;